const config = {
  // Frontend config
  // FOO:'bar'
  // Backend config
  apiGateway: {
    REGION: process.env.NEXT_PUBLIC_AWS_REGION ?? 'us-east-1',
    URL: process.env.NEXT_PUBLIC_API_URL ?? '',
    EMAIL_API_KEY: process.env.NEXT_PUBLIC_EMAIL_API_KEY ?? '',
  },
};

export default config;
